// External UI components
import KwButton from '@kiwitaxi/vue-components/dist/KwButton';
import KwInput from '@kiwitaxi/vue-components/dist/KwInput';
import KwButtonGroup from '@kiwitaxi/vue-components/dist/KwButtonGroup';
import KwDropdown from '@kiwitaxi/vue-components/dist/KwDropdown';
import KwSelect from '@kiwitaxi/vue-components/dist/KwSelect';
import KwSvgicon from '@kiwitaxi/vue-components/dist/KwSvgicon';

// External UI Containers
import KwFormGroup from '@kiwitaxi/vue-components/dist/KwFormGroup';
import KwPanel from '@kiwitaxi/vue-components/dist/KwPanel';

// UI Elements
import Svgicon from './Svgicon.vue';
import KwCheckbox from './KwCheckbox.vue';
import KwSpinner from './KwSpinner.vue';

// UI Containers
import KwFlatpickerWrapper from './KwFlatpickerWrapper.vue';

// UI Components
import KwPagination from './KwPagination.vue';
import KwPhoneInput from './KwPhoneInput.vue';
import KwTimepicker from './KwTimepicker';

export {
  // UI Elements
  KwButton,
  KwInput,
  KwCheckbox,
  KwSelect,
  KwSpinner,
  KwSvgicon,
  Svgicon,

  // UI Components
  KwPagination,
  KwPhoneInput,
  KwTimepicker,

  // UI Containers
  KwButtonGroup,
  KwDropdown,
  KwFormGroup,
  KwPanel,
  KwFlatpickerWrapper,
};



// WEBPACK FOOTER //
// ./src/components/UI/index.js